module.exports = __webpack_public_path__ + "img/1429466709.23606675.jpg";